export default {
  namespaced: true,
  state: {
    id: null,
  },
  actions: {
    async setId({ commit }, { id }) {
      commit('setId', { id });
    },
  },
  mutations: {
    setId(state, { id }) {
      state.id = id;
    },
  },
};
